"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapReducer = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _uuid = require("uuid");

var _statusEnum = _interopRequireDefault(require("./statusEnum"));

var actions = _interopRequireWildcard(require("./apiActions"));

var _Api = require("./Api");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function requestStatus(currentStatus) {
  if ([_statusEnum["default"].SUCCESS, _statusEnum["default"].RELOADING].includes(currentStatus) === false) {
    return _statusEnum["default"].REQUESTED;
  }

  return _statusEnum["default"].RELOADING;
}

var handleTransform = function handleTransform(_ref) {
  var action = _ref.action,
      state = _ref.state,
      endpoint = _ref.endpoint;
  var endpointName = action.endpointName,
      requestOptions = action.requestOptions,
      error = action.error,
      _action$stateOptions = action.stateOptions,
      stateOptions = _action$stateOptions === void 0 ? {} : _action$stateOptions;

  switch (action.type) {
    case actions.API_CALL_REQUESTED:
      {
        return _objectSpread(_objectSpread(_objectSpread({}, state), stateOptions), {}, {
          errors: (0, _utils.removeError)(state.errors, endpointName),
          status: _objectSpread(_objectSpread({}, state.status), {}, (0, _defineProperty2["default"])({}, endpointName, requestStatus(state.status[endpointName])))
        });
      }

    case actions.API_CALL_SUCCESS:
      {
        var transformedResponse = endpoint.transformResponse({
          data: action,
          endpointName: endpointName,
          state: state,
          requestOptions: requestOptions
        });
        return _objectSpread(_objectSpread(_objectSpread({}, state), transformedResponse.response), {}, {
          errors: (0, _utils.removeError)(state.errors, endpointName),
          status: _objectSpread(_objectSpread({}, state.status), {}, (0, _defineProperty2["default"])({}, endpointName, _statusEnum["default"].SUCCESS))
        });
      }

    case actions.API_CALL_ERROR:
      {
        var errors = [{
          uuid: (0, _uuid.v4)(),
          endpointName: endpointName,
          error: error
        }].concat((0, _toConsumableArray2["default"])(state.errors));
        return _objectSpread(_objectSpread({}, state), {}, {
          errors: errors,
          status: _objectSpread(_objectSpread({}, state.status), {}, (0, _defineProperty2["default"])({}, endpointName, _statusEnum["default"].ERROR))
        });
      }

    default:
      return action;
  }
};

var handleApiData = function handleApiData(state, action) {
  var isNotApiAction = ![actions.API_CALL_REQUESTED, actions.API_CALL_SUCCESS, actions.API_CALL_ERROR].includes(action.type);

  if (isNotApiAction) {
    return state;
  }

  var apiReference = action.apiReference,
      endpointName = action.endpointName;

  var endpoint = _Api.apiServices.getEndpoint({
    apiReference: apiReference,
    endpointName: endpointName
  });
  /** Warn the user if the reducer name was not defined */


  if (state[endpoint.reducer] === undefined) {
    console.warn("SPQ Redux Api Client: The reducer name given (".concat(endpoint.reducer, ") does not exist as part of application state"));
    return state;
  }
  /* Reducer name given by user (place transformed data will be stored) should be a string with length > 0 */


  if (typeof endpoint.reducer !== "string" || endpoint.reducer.length === 0) {
    console.warn("SPQ Redux Api Client: reducer name given to endpoints should be a string with at least one character");
    return state;
  }

  return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2["default"])({}, endpoint.reducer, handleTransform({
    action: action,
    state: state[endpoint.reducer],
    endpoint: endpoint
  })));
};

var wrapReducer = function wrapReducer(rootReducer) {
  return function (state, action) {
    var nextState = rootReducer(state, action);
    /* If state is not equal, user has handled action already */

    if (!(0, _lodash.isEqual)(state, nextState)) {
      return nextState;
    }

    return handleApiData(state, action);
  };
};

exports.wrapReducer = wrapReducer;